module.exports = __webpack_public_path__ + "static/media/notaccess.a89b79c5.svg";